import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getSnowboardsWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const snowGear = categorySpecificInfo.snowGear;
  if (!isRecord(snowGear)) {
    return [];
  }

  const snowboards = snowGear.snowboards;
  if (!isRecord(snowboards)) {
    return [];
  }

  const attachments = snowboards.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withSnowboardsWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const snowGear = isRecord(categorySpecificInfo.snowGear)
    ? categorySpecificInfo.snowGear
    : {};
  const snowboards = isRecord(snowGear.snowboards) ? snowGear.snowboards : {};
  const attachments = isRecord(snowboards.attachments)
    ? snowboards.attachments
    : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      snowGear: {
        ...snowGear,
        snowboards: {
          ...snowboards,
          attachments: {
            ...attachments,
            warranty: {
              ...warranty,
              files,
            },
          },
        },
      },
    },
  };
};

export const persistSnowboardsWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(
    db,
    `users/${userId}/vcards/active`,
    "snowGear_snowboards",
  );
  await updateDoc(vcardRef, {
    "categorySpecificInfo.snowGear.snowboards.attachments.warranty.files":
      files,
    updatedAt: serverTimestamp(),
  });
};
